





























import { Component, Vue, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { SystemApi, ValueListItem, WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: { EditOnClickField },
  computed: mapGetters({
    ordersApi: 'ordersApi',
    systemApi: 'systemApi'
  })
})
export default class JobTypeEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: 'Job Type' })
  private label!: string;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number | undefined;

  private jobTypeMode = 'read';
  private jobTypes!: ValueListItem[];

  private loading!: boolean;

  private ordersApi!: WorkordersApi;
  private systemApi!: SystemApi;

  data() {
    return {
      jobTypes: undefined,
      loading: false
    };
  }

  private async mounted() {
    this.jobTypes = await this.systemApi.getValueListItems({
      propertyId: this.propertyId,
      name: 'Job Types'
    });
  }

  private async handleJobTypeChange(jobType: string) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === jobType) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeJobType({
        workorderId: this.workorderId,
        changeOrderJobTypeCommand: {
          newJobType: jobType
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.jobTypeMode = 'read';
    this.loading = false;
  }
}
